import { pick } from 'lodash/fp';
import { useTranslation } from 'next-i18next';
import { EShareType, TShareLinks } from './fdr-share-overlay.types';
import { TBookmarkInfo } from './fdr-use-share-links.types';
import {
  download,
  facebook,
  mail,
  twitter,
  whatsapp,
} from './fdr-use-share-links.utils';

const getShareLinks = (
  title: string,
  toShare: string | TBookmarkInfo[],
  body: (text: string) => string
): TShareLinks => {
  return {
    [EShareType.FACEBOOK]: facebook(toShare),
    [EShareType.X]: twitter(title, toShare),
    [EShareType.WHATSAPP]: whatsapp(toShare),
    [EShareType.MAIL]: mail(title, toShare, body),
    [EShareType.DOWNLOAD]: download(title, toShare),
  };
};

export const useShareLinks = (
  title: string,
  toShare: string | TBookmarkInfo[],
  whiteList: Array<EShareType> = [
    EShareType.FACEBOOK,
    EShareType.X,
    EShareType.WHATSAPP,
    EShareType.MAIL,
  ],
  isCatalog?: boolean
): TShareLinks => {
  const [t] = useTranslation('common');

  const urls = getShareLinks(title, toShare, text =>
    t(isCatalog ? 'share.wishlist.catalog.mail' : 'share.wishlist.mail', {
      text,
    })
  );
  return pick(whiteList, urls);
};
